import { ButtonDS, GlobalIcon, TextInput } from "get-life-storybook-ts";
import PersonalDataController from "../../../PaymentGateway/components/PersonalData/PersonalData.controller";
import FormLabel from "./FormLabel.component";

interface PersonalDataSectionProps {
  userData: any;
  saveData: (data: any) => void;
  done: boolean;
  onEdit: () => void;
  translate: (key: string) => string;
}

const PersonalDataSection = ({
  userData,
  saveData,
  done,
  onEdit,
  translate,
}: PersonalDataSectionProps) => {
  const {
    error,
    lastName,
    lastName2,
    name,
    email,
    setEmail,
    phone,
    sendPersonalData,
    setLastName,
    setLastName2,
    setName,
    setPhone,
    validations,
    showEmail,
  } = PersonalDataController({ userData, saveData });

  const isEs = process.env.REACT_APP_DOMAIN_LOCALE === "es";

  return (
    <section className="paymentV3Section">
      <FormLabel
        num="01"
        title={translate("paymentV3.section.personalData.title")}
        active={!done}
        done={done}
      />
      <div
        className={`paymentV3Section__body paymentV3Section__personalGrid ${
          done ? "paymentV3Section__body--locked" : ""
        }`}
      >
        <TextInput
          initialValue={name}
          initialError={error.name}
          label={translate("payment.personalData.name")}
          onValueChange={setName}
          placeholder={translate("payment.personalData.namePlaceHolder")}
          validationChecks={validations.name}
        />
        <TextInput
          initialValue={lastName}
          initialError={error.lastName}
          label={translate("payment.personalData.surname")}
          onValueChange={setLastName}
          placeholder={translate("payment.personalData.surnamePlaceHolder")}
          validationChecks={validations.lastName}
        />
        {isEs && (
          <TextInput
            initialValue={lastName2}
            label={translate("payment.personalData.lastname")}
            onValueChange={setLastName2}
            placeholder={translate("payment.personalData.lastnamePlaceHolder") || "Opcional"}
          />
        )}
        <TextInput
          label={translate("payment.personalData.phone")}
          onValueChange={setPhone}
          placeholder={translate("payment.personalData.phonePlaceHolder")}
          initialValue={phone}
          initialError={error.phone}
          validationChecks={validations.phone}
          inputMode="numeric"
        />
        {showEmail && (
          <div className="paymentV3Section__personalEmail">
            <TextInput
              label={translate("payment.personalData.email")}
              onValueChange={setEmail}
              placeholder={translate("payment.personalData.emailPlaceHolder")}
              initialValue={email}
              initialError={error.email}
            />
          </div>
        )}
      </div>

      {!done ? (
        <div className="paymentV3Section__cta paymentV3Section__cta--end">
          <ButtonDS
            label={translate("paymentV3.section.personalData.continue")}
            onClick={() => sendPersonalData()}
            rightIcon="ArrowRightIcon"
          />
        </div>
      ) : (
        <div className="paymentV3Section__cta paymentV3Section__cta--end">
          <button
            type="button"
            className="paymentV3Section__editLink"
            onClick={onEdit}
          >
            <GlobalIcon iconName="EditIcon" size="XS" color="#423EF4" />
            {translate("paymentV3.section.personalData.edit")}
          </button>
        </div>
      )}
    </section>
  );
};

export default PersonalDataSection;
